import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CorrelationState } from "./correlationTypes";
import { CorrelationResultType, correlationApi } from "../../../app/apislices/correlationApi";

const initialState: CorrelationState = { selectedResultType: "count", isDialogOpen: false };

const correlationSlice = createSlice({
  name: "correlationSlice",
  initialState,
  reducers: {
    setSelectedResultType: (state, action: PayloadAction<CorrelationResultType>) => {
      state.selectedResultType = action.payload;
    },
    setIsDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.isDialogOpen = action.payload;
    },
  },
});

export const { setSelectedResultType, setIsDialogOpen } = correlationSlice.actions;

export default correlationSlice.reducer;

correlationApi.enhanceEndpoints({
  endpoints: {
    getCorrelationGet: {
      providesTags: [],
    },
  },
});
